/**
 * Sprint T-18 · Notification Studio · Analytics · Counters row.
 *
 * 5 numeric widgets · Sent · Delivered vs Failed · Retried · DLQ · Success%.
 */
import React from "react";
import { Loader2 } from "lucide-react";

function Counter({ label, value, subtitle, testid, tone = "neutral" }) {
  const toneCls =
    tone === "success"
      ? "text-emerald-300"
      : tone === "danger"
      ? "text-rose-300"
      : tone === "warn"
      ? "text-amber-300"
      : "text-[var(--ag-text)]";
  return (
    <div
      className="rounded border border-[var(--ag-border)] bg-[var(--ag-panel)] p-3"
      data-testid={testid}
    >
      <div className="text-[10px] uppercase tracking-widest text-[var(--ag-text-dim)]">
        {label}
      </div>
      <div className={`font-display text-3xl font-bold tracking-tight ${toneCls}`}>
        {value ?? "—"}
      </div>
      {subtitle && (
        <div className="mt-1 text-[10px] text-[var(--ag-text-dim)]">{subtitle}</div>
      )}
    </div>
  );
}

export default function AnalyticsCounters({ data, loading }) {
  if (loading && !data) {
    return (
      <div className="flex items-center gap-2 text-xs text-[var(--ag-text-dim)]">
        <Loader2 size={12} className="animate-spin" />
        Cargando counters…
      </div>
    );
  }
  const total = data?.total ?? 0;
  return (
    <div
      className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6"
      data-testid="studio-analytics-counters"
    >
      <Counter
        label="Total"
        value={total}
        subtitle={`${data?.days ?? "?"}d window`}
        testid="studio-analytics-counter-total"
      />
      <Counter
        label="Sent"
        value={data?.sent ?? 0}
        subtitle={`${data?.success_pct ?? 0}% success`}
        testid="studio-analytics-counter-sent"
        tone="success"
      />
      <Counter
        label="Failed"
        value={data?.failed ?? 0}
        testid="studio-analytics-counter-failed"
        tone={data?.failed ? "danger" : "neutral"}
      />
      <Counter
        label="Retried"
        value={data?.retried ?? 0}
        testid="studio-analytics-counter-retried"
        tone="warn"
      />
      <Counter
        label="DLQ"
        value={data?.dlq ?? 0}
        testid="studio-analytics-counter-dlq"
        tone={data?.dlq ? "danger" : "neutral"}
      />
      <Counter
        label="Dry-run"
        value={data?.dry_run ?? 0}
        subtitle={`${data?.dry_run_pct ?? 0}% del total`}
        testid="studio-analytics-counter-dry-run"
      />
    </div>
  );
}
